import { useEffect, useRef, useState } from 'preact/hooks';

type ImportFn = () => Promise<any>;
interface ComponentState {
  C: JSX.Element | (() => JSX.Element);
}

const lazyLoad =
  (importFn: ImportFn, fallback: () => JSX.Element, _loaded?: JSX.Element) =>
  (
    props: any,
    context: any,
    [{ C }, set] = useState<ComponentState>({ C: _loaded || fallback }),
    unmounted = useRef(0),
  ) => (
    useEffect(
      () => (
        !_loaded &&
          importFn().then(
            ({ default: comp }) => ((_loaded = comp), unmounted.current || set({ C: comp })),
          ),
        () => (unmounted.current = 1)
      ),
      [set, unmounted],
    ),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    C ? <C {...props} /> : null
  );

export { lazyLoad };
